import { Date as ApiDate } from 'gabi-api-ts/v2/common/date/date';

export function formatDateForUrl(date: Date): string {
    const dateYear = date.getFullYear();
    const month = date.getMonth()+1;
    const monthStr = `${month < 10 ? '0' : ''}${month}`;
    const day = date.getDate();
    const dayStr = `${day < 10 ? '0' : ''}${day}`;
    return `${dateYear}-${monthStr}-${dayStr}`;
}

export function formatApiDateForUrl(apiDate: ApiDate): string {
    const month = `${apiDate.month < 10 ? '0' : ''}${apiDate.month}`;
    const day = `${apiDate.day < 10 ? '0' : ''}${apiDate.day}`;
    return `${apiDate.year}-${month}-${day}`;
}
